import React, { useEffect, useRef, useState } from 'react';
import { Col, Row } from 'react-flexbox-grid';
import { Checkbox } from 'antd';
import '../PreEFormMapping/ipsMapping.css';
import Expand from '../ExpandIcon';
import PreEFormAssetMapping from '../PreEFormAssetMapping';
import AssetMappingHeader from '../PreEFormAssetMapping/AssetMappingHeader';
import tick from '../../../assets/Tick.png';
import PreFormExceptionAssetMapping from '../PreEFormAssetMapping/PreFormExceptionAssetMapping';


const ipscss = {
    marginLeft: '0px',
    marginRight: '0px'
}

const moveleft = {
    marginLeft: '-15px',
    alignItems: 'center'
}
const PreFormExceptionMapping = (props) => {
    const { id, ipsLocationId, selected, preEFormMapping, currentFormId, onChangeAssetId, assetId, selectAllAssets, saveVisibleText, handleCheckboxSelect, selectedAssets, handleIpsLocationSelect,editVisibleProps, checkBoxHidden } = props;
    const [setActive, setAtiveState] = useState("");
    const [setBGColor, setColorState] = useState("white");
    const [color, setColor1] = useState("white");
    const [checkDisplay, setCheckDisplay] = useState("none");
    const [setHeight, setHeightState] = useState("0px");
    const [setRotate, setRotateState] = useState("accordion_icon");
    let assets = preEFormMapping.assets;

    const content = useRef(null);

    const toggleAccordion = () => {
        setAtiveState(setActive === "" ? "active" : "");
        setHeightState(setActive === "active" ? "0px" : `${content.current.scrollHeight>250?250:content.current.scrollHeight}px`);
        setColorState(setActive === "active" ? "white" : "white");
        setColor1(setActive === "active" ? "white" : "black");
        setCheckDisplay(setActive === "active" ? "none" : "flex");
        setRotateState(setActive === "active" ? " accordion_icon" : "accordion_icon rotate");
    }

    const isAllSelected =(assets, selectedAssets) => {
        return selectedAssets && selectedAssets[0]?.assetIds.length===assets.length
    }

    useEffect(() => {
        if (preEFormMapping.setActive !== null && preEFormMapping.setActive !== 'undefined') {
            setAtiveState(preEFormMapping.setActive);
            setHeightState(preEFormMapping.setActive === "active" ? preEFormMapping.setHeight : "0px");
            setColorState(preEFormMapping.setActive === "active" ? "white" : "white");
            setColor1(preEFormMapping.setActive === "active" ? "black" : "white");
            setCheckDisplay(preEFormMapping.setActive === "active" ? "flex" : "none");
            setRotateState(preEFormMapping.setActive === "active" ? "accordion_icon rotate" : " accordion_icon");
        }
    }, []);


    return (
        <Row style={ipscss}
            className={`tasklist--row`}
        >
            <Col lg={12} className="tasklist--description" style={moveleft}>

                <a id={preEFormMapping.ipsLocationId} className={`accordion ${setActive}`} onClick={() => toggleAccordion()}>
                    <Expand className={`${setRotate}`} width="15px" fill={"#777"} />
                </a>
                <span style={{ marginRight: "15px" }}>
                </span>

                <div className="tasklist--checkbox">
                   {!checkBoxHidden &&
                        <Checkbox
                            disabled={editVisibleProps}
                            checked={isAllSelected(assets, selectedAssets)}
                            onClick={() => handleIpsLocationSelect(preEFormMapping)}
                        /> 
                   }

                </div>
                <div>{preEFormMapping.ipsLocationName}</div>
            </Col>

            <Col lg={12} xl={12} sm={6} >
                <div className="col-lg-12 accordion__content" ref={content} style={{
                    maxHeight: `${setHeight}`,
                    backgroundColor: `${setBGColor}`,
                    color: `${color}`,
                    checkBoxColor: `${checkDisplay}`,
                    rotate: `${setRotate}`,
                }}>
                    <AssetMappingHeader />
                    {assets && assets.map(asset => (
                        <PreFormExceptionAssetMapping exceptionId={preEFormMapping.exceptionId || preEFormMapping.jobJournalId} selected={selectedAssets && selectedAssets[0]?.assetIds.includes(asset.assetId)} asset={asset} onChangeAssetId={onChangeAssetId} setActive={setActive} setHeight={setHeight} saveVisibleText={saveVisibleText} handleCheckboxSelect={handleCheckboxSelect} editVisibleProps={editVisibleProps} {...props} />))}

                </div>
            </Col>

        </Row>

    );
}
export default PreFormExceptionMapping;
